const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/assets/$assetId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { type UpdateAssetRequest } from "@/types/api/asset";
import { createFileRoute } from "@tanstack/react-router";
import * as z from "zod";
export const Route = createFileRoute("/client/assets/$assetId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
const assetSchema = z.object({
  assetName: z.string().min(1, "Asset Name is required"),
  identifyingNumber: z.string().optional(),
  serialNumber: z.string().optional(),
  description: z.string().optional(),
  assetType: z.string().optional(),
  // Using string for select value, will cast to Enum or number
  manufacturerName: z.string().optional(),
  modelNumber: z.string().optional(),
  installationDate: z.string().optional(),
  locationId: z.string().min(1, "Location is required"),
  assetGroupId: z.string().min(1, "Asset Group is required"),
  isActive: z.boolean()
});
type AssetFormValues = z.infer<typeof assetSchema>;